import AppConfig from "../../constants";
import { loadLocalData } from "@/utils/common-util";
import axios from "axios";

let apiClient = axios.create({
  baseURL: AppConfig.API_SERVER,
  headers: {
    "Content-Type": "application/json",
  },
});

let apiFileClient = axios.create({
  baseURL: AppConfig.API_SERVER,
  // multipart/form-data는 axios가 자동으로 boundary를 포함한 Content-Type을 설정합니다
});

// NOTE(happyhyep): 공통 응답 언래핑 인터셉터
apiClient.interceptors.response.use(
  (response) => {
    const payload = response?.data;
    // NOTE(happyhyep): CommonResponseDto 형태면 그대로 유지 (호출부에서 ResponseDto로 다시 포맷)
    // NOTE(happyhyep): 여기서는 성공 여부에 따라 적절히 반환
    if (payload && typeof payload.success === "boolean") {
      if (payload.success) {
        return response; // NOTE(happyhyep): 호출부에서 ResponseDto(new)로 처리
      }
      // NOTE(happyhyep): 실패라면 에러로 전달
      return Promise.reject({
        isCommonResponse: true,
        status: payload.statusCode ?? response.status,
        message: payload.message,
        error: payload.error,
        raw: response,
      });
    }
    // NOTE(happyhyep): 레거시나 비표준 응답은 그대로 반환
    return response;
  },
  (error) => {
    // NOTE(happyhyep): 네트워크/HTTP 에러도 통일된 형태로 래핑
    const resp = error?.response;
    const payload = resp?.data;
    if (payload && typeof payload.success === "boolean") {
      return Promise.reject({
        isCommonResponse: true,
        status: payload.statusCode ?? resp?.status,
        message: payload.message,
        error: payload.error,
        raw: resp,
      });
    }
    return Promise.reject(error);
  },
);

export const setApiBaseUrl = (url: string) => {
  if (apiClient) apiClient.defaults.baseURL = url;
};

// export const setAuthorizationToken = (token: string) => {
//   if (token) {
//     axios.defaults.headers.common["Authorization"] = `Vote ${token}`;
//   } else {
//     delete axios.defaults.headers.common["Authorization"];
//   }
// };

export function setApiToken(token: string): void {
  if (apiClient)
    apiClient.defaults.headers.common["Authorization"] = "Bearer " + token;
  if (apiFileClient)
    apiFileClient.defaults.headers.common["Authorization"] = "Bearer " + token;
}

export const getApiClient = () => {
  const token = loadLocalData(AppConfig.KEYS.LOGIN_TOKEN);
  if (token) setApiToken(token);
  if (!apiClient) {
    apiClient = axios.create({
      baseURL: AppConfig.API_SERVER,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  return apiClient;
};

export const getFileApiClient = () => {
  const token = loadLocalData(AppConfig.KEYS.LOGIN_TOKEN);
  if (token) setApiToken(token);
  if (!apiFileClient) {
    apiFileClient = axios.create({
      baseURL: AppConfig.API_SERVER,
      // multipart/form-data는 axios가 자동으로 boundary를 포함한 Content-Type을 설정합니다
    });
  }
  return apiFileClient;
};
